import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Landing from "@/pages/Landing";
import SignInPage from "@/pages/SignInPage";
import SignUpPage from "@/pages/SignUpPage";
import Dashboard from "@/pages/Dashboard";
import CategoryPage from "@/pages/CategoryPage";
import QuizPlay from "@/pages/QuizPlay";
import Leaderboard from "@/pages/Leaderboard";
import Submit from "@/pages/Submit";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Profile from "@/pages/Profile";
import Classes from "@/pages/Classes";
import Teach from "@/pages/Teach";
import RequireAuth from "@/components/RequireAuth";
import { BrandingEffects } from "@/lib/branding";
import { Privacy, Terms, DeleteAccount } from "@/pages/Legal";

const guard = (el) => <RequireAuth>{el}</RequireAuth>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Toaster position="top-center" richColors />
          <BrandingEffects />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="/play" element={<Dashboard />} />
            <Route path="/category/:id" element={<CategoryPage />} />
            <Route path="/quiz/:id" element={guard(<QuizPlay />)} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/pricing" element={guard(<Pricing />)} />
            <Route path="/payment/success" element={guard(<PaymentSuccess />)} />
            <Route path="/payment/cancel" element={guard(<PaymentCancel />)} />
            <Route path="/profile" element={guard(<Profile />)} />
            <Route path="/classes" element={guard(<Classes />)} />
            <Route path="/teach" element={guard(<Teach />)} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
